import { render, staticRenderFns } from "./PackScanTest.vue?vue&type=template&id=35a10725&scoped=true&"
import script from "./PackScanTest.vue?vue&type=script&lang=js&"
export * from "./PackScanTest.vue?vue&type=script&lang=js&"
import style0 from "./PackScanTest.vue?vue&type=style&index=0&id=35a10725&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a10725",
  null
  
)

export default component.exports